import { css } from '@emotion/css'
import { fontSize, fontWeight, spacing } from '../../styles'
import getThemeColors, { colors } from '../../themes'

const styles = {
  wrapper: css({
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.2,
    color: colors.jumbo,
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    justifyContent: 'center',

    '& > * + *': {
      marginLeft: spacing.default,
    },
  }),

  page: css({
    userSelect: 'none',
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: colors.mystic,
    },

    '&:focus': {
      outline: 'none',
      backgroundColor: colors.geyser,
    },
  }),

  pageHidden: css({
    visibility: 'hidden',
  }),

  pageDisabled: css({
    pointerEvents: 'none',
  }),
}

export default styles

export const pageTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    backgroundColor: themed.base,
    color: colors.white,
    pointerEvents: 'none',
  })
}
